export const ApiConstants = {
    Login: '/sign-in',
    Register: '/sign-up',
    VerifyOtp: '/verify-otp',
    ForgotPassword: '/forgot-password',
    ResetPassword: '/reset-password',
    ResendOtp: '/resend-otp',
    Changepassword: '/change-password',

    Category: 'categories/get',
    ProfileGetCategory: 'categories/get-list',
    AddCategory: 'categories/create',

    Services: 'services/get',
    ProfileSetup: '/profile-setup',
    GetProfile: '/profile',
    ProfileDetail: '/complete-profile',

    ResubmitProfile: "resubmit-profile",
    DetailProfile: "salon-profile",

    RemoveProfileImage: "remove-profile-image",

    CmsPage: "cms-pages/detail",
    FaqGet: "faqs/get",
    AppFaqGet: "faqs/get",


    BillingManagementList:"billing/get-list",
    BillingManagementDetail:"billing/detail",


    /*dashboard */
    ContactSupport: 'contact-us/create',

    AddService: 'services/create',
    ServiceManagementList: "services/get",
    ServiceManagementDelete: "services/delete",
    ServiceManagementStatus: "services/status",
    ServiceManagementDetail: "services/detail",
    ServiceManagementUpdate: "services/update",


    DashboardDetailGet:"dashboard/get-booking",
    DashboardBookingDetail:"dashboard/booking-detail ",
    DashboardBookingViewDetail:"dashboard/view-booking-detail",
    DashboardStatusChangeBooking:"booking/manage-booking",
    DashboardBookingMarkadCompleted:"booking/booking-service-list",
    BookingServiceRemove:"booking/service-delete",
    BookinMarkAsCompleted:"booking/mark-as-complete",
    OfflineBooking:'offline-booking/create',

    // Staff management
    StatffMemberServiceListGet: "staff-member/get-list",
    StatffMemberGet: "staff-member/Get",
    StatffMemberAdd: "staff-member/create",
    StatffMemberUpdate: "staff-member/update",
    StatffMemberDelete: "staff-member/delete",
    StatffMemberDetail: "staff-member/details",
    StatffMemberStatus: "staff-member/status",
    StatffMemberCategoryGet: "categories/get-services",
    StatffMemberViewDetails: "staff-member/view-detail",


    // My-profile
    MyProfileDetail: "/my-profile",
    MyProfileUpdate: "/salon-owner-update",
    MyProfileSalonUpdate: "/salon-update",
    SalonDetail: "/salon-profile-detail",


    // Salon-availability 
    SalonAvailabilityDetail: "/salon-availability/detail",
    StaffAvailabilityDetail: "/salon-availability/detail",
    SalonAvailabilityUpdate: "/salon-availability/update",
    SalonAvailabilityStaffUpdate: "/staff-member/update-availability",
    BlockServiceReason: "/attribs/get",
    BlockService: "/salon-availability/block",




    // Cancel Booking Reason
    CancelBookingReason:"",
    NotificationGet:"notifications/get-list",


    SalesGrowthGet:"sales-growth/get",
    SalesGrowthCount:"sales-growth/count",
    HomeCategory:"home/get",

    OfflineSubscriptionPlans: "offline-subscription/plans",
    OfflineSubscriptionBankDetails: "offline-subscription/bank-details",
    OfflineSubscriptionMyRequests: "offline-subscription/my-requests",
    OfflineSubscriptionSubmitPayment: "offline-subscription/submit-payment",

}   